import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader } from '../_helpers/auth-header';

import {config} from '../config';
const base_url = config.apiUrl;

export const attachmentService = {
  attach,
  getById,
  delete: _delete
};

function attach(form) {
  const url = base_url + 'Attachment/AttachImage';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, form, { headers: authHeader()});
}

function getById(id) {
  const url = base_url + 'Attachment//' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function _delete(id) {
  const url = base_url + 'Attachment//' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader()});
}
